import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "../../utils/supabaseClient";
import { EmailVerification } from "../../components/verification/EmailVerification";

type VerificationStatus = "loading" | "success" | "error";

export const SignupConfirmation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<VerificationStatus>("loading");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const tokenHash = searchParams.get("token_hash");
    const type = searchParams.get("type");

    if (!tokenHash) {
      setStatus("error");
      setError("Verification token is missing");
      return;
    }

    if (type !== "signup") {
      setStatus("error");
      setError("Invalid verification type");
      return;
    }

    const verifySignup = async () => {
      try {
        const { error: verifyError } = await supabase.auth.verifyOtp({
          token_hash: tokenHash,
          type: "signup",
        });

        if (verifyError) {
          setStatus("error");
          setError(verifyError.message || "Failed to verify email. The link may have expired.");
          return;
        }

        setStatus("success");

        // Redirect to login after a short delay
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } catch (err) {
        setStatus("error");
        setError("Network error. Please check your connection and try again.");
      }
    };

    verifySignup();
  }, [searchParams, navigate]);

  return (
    <EmailVerification
      status={status}
      loadingMessage="Confirming your email..."
      successMessage="Your email has been confirmed! Redirecting to login..."
      errorMessage={error}
      onErrorAction={() => navigate("/signup")}
      errorActionLabel="Back to Sign Up"
    />
  );
};
